import { FormGroup } from '@angular/forms';

export type ChopServerValidationErrorCode = 'NotUnique' | 'Invalid';

export interface ChopServerValidationError {
  field?: string;
  error?: ChopServerValidationErrorCode;
}

export function applyChopServerValidationError(
  form: FormGroup,
  body: ChopServerValidationError | null | undefined,
  fieldMap: Readonly<Record<string, string>>
): boolean {
  const field = body?.field;
  const error = body?.error;
  if (!field || !error) {
    return false;
  }
  const controlPath = fieldMap[field];
  if (!controlPath) {
    return false;
  }
  const control = form.get(controlPath);
  if (!control) {
    return false;
  }
  control.setErrors({ [error]: true });
  control.markAsTouched();
  return true;
}
